import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {DeepResearchMessageType} from 'llm/deep-research/types';
import {FONT_PROXIMA_14, FONT_WEIGHT_PROXIMA_REGULAR} from 'styles/FontConstants';
import {GRAY_LIGHTER} from 'ui-library/Colors';

export interface UserDeepResearchMessage {
  type: DeepResearchMessageType.USER_MESSAGE;
  content: string;
}

export function UserMessage({message}: {message: UserDeepResearchMessage}): JSX.Element {
  return (
    <div className={css(styles.userMessageLayout)} data-testid="user-message">
      <div className={css(styles.userMessageContainer)}>{message.content}</div>
    </div>
  );
}

const styles = StyleSheet.create({
  // User message styles
  userMessageLayout: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  userMessageContainer: {
    padding: '12px',
    maxWidth: 'min(400px, 80%)',
    backgroundColor: GRAY_LIGHTER,
    borderRadius: '4px',
    ...FONT_PROXIMA_14,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
  },
});
